import dayjs from "dayjs";
import { z } from "zod";

const message = { message: "Обязательное поле" };

const isDayjs = z.custom<dayjs.Dayjs>(
  (val) => dayjs.isDayjs(val) && val.isValid(),
  message,
);

const isDayjsOptional = z.custom<dayjs.Dayjs | null>((val) => {
  return (
    val === undefined || val === null || (dayjs.isDayjs(val) && val.isValid())
  );
}, message);

export const DocumentationPermissionSchema = z.object({
  documentationPermissionId: z.string().optional(),
  number: z.string(message),
  date: isDayjs,
  issued: z.string(message),
  expiryDate: isDayjsOptional.nullable(),
  prolongDate: isDayjsOptional.nullable(),
  file: z
    .object({
      file: z.instanceof(File).nullable().optional(),
      id: z.string().optional(),
    })
    .nullable()
    .optional(),
});

const DocumentationExaminationSchema = z.object({
  documentationExaminationId: z.string().optional(),
  number: z.string(message),
  date: isDayjs,
  issued: z.string(message),
  file: z
    .object({
      file: z.instanceof(File).nullable().optional(),
      id: z.string().optional(),
    })
    .nullable()
    .optional(),
});

const ExaminationsBlockSchema = z.discriminatedUnion("required", [
  z.object({
    required: z.literal(true),
    documentationExaminations: DocumentationExaminationSchema.array(),
  }),
  z.object({
    required: z.literal(false),
    documentationExaminations: DocumentationExaminationSchema.partial()
      .array()
      .optional(),
  }),
]);

const PermissionsBlockSchema = z.discriminatedUnion("required", [
  z.object({
    required: z.literal(true),
    documentationPermissions: DocumentationPermissionSchema.array(),
  }),
  z.object({
    required: z.literal(false),
    documentationPermissions: DocumentationPermissionSchema.partial()
      .array()
      .optional(),
  }),
]);

export const ObjectFormEditSchema = z.object({
  fullName: z.string(),
  shortName: z.string(),
  descriptionProjects: z.string(message),
  descriptionStage: z.string().nullish(),
  constructionType: z.enum(["CONSTRUCTION", "RECONSTRUCTION", "RENOVATION"]),
  permissions: PermissionsBlockSchema.optional(),
  deletedPermissions: z.set(z.string()).optional(),
  examinations: ExaminationsBlockSchema.optional(),
  deletedExaminations: z.set(z.string()).optional(),
  buildingStart: isDayjs,
  buildingEnd: isDayjs,
});
